import { Button, Col, Row, Breadcrumb, Space, Table, Typography, Popconfirm } from 'antd';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import axios from 'axios';
import { CheckCircleFilled, CloseCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { API_HOST } from '../../helpers/constants';
import { openNotification } from '../../helpers';
import { usePages } from '../../hooks/usePages';
import { headers } from '../../utils';
import { useState } from 'react';

function PagesList() {
  const [allParams, setAllParams] = useState({});
  const url = `${API_HOST}/pages`;

  const { pages, meta, isLoading, revalidate } = usePages(allParams);

  const onDeleteClick = async (id) => {
    try {
      await axios.delete(`${url}/${id}`, { headers });
      revalidate();
      openNotification('Success', `Deleted successfully!`);
    } catch (e) {
      console.log(e);
    }
  };

  const onTableChange = async (pagination, filters, sorter) => {
    const options = {
      // term: searchText,
      limit: pagination.pageSize,
      skip: (pagination.current - 1) * pagination.pageSize,
      sort: sorter.order === 'descend' ? `-${sorter.field}` : sorter.field,
      ...filters
    };

    await setAllParams(options);
  };

  const columns = [
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
      render: (text, row) => {
        return (
          <div className="ml-2">
            <Link to={`/pages/${row._id}/edit`} className="font-semibold">
              {text}
            </Link>
            <p className="text-sm text-gray-500">{row.slug}</p>
          </div>
        );
      }
    },

    {
      title: 'Active?',
      dataIndex: 'isActive',
      key: 'isActive',
      align: 'center',
      render: (text) =>
        text ? (
          <CheckCircleFilled className="text-green-500 text-lg" />
        ) : (
          <CloseCircleOutlined className="text-red-500 text-lg" />
        )
    },
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (text) => dayjs(text).format('DD/MM/YYYY hh:mm a')
    },

    {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <Space size="middle">
          <Link to={`/pages/${record._id}/edit`}>Edit</Link>
          <Popconfirm
            title="Are you sure to delete?"
            okText="Yes"
            cancelText="No"
            onConfirm={() => onDeleteClick(record._id)}>
            <a href="#">Delete</a>
          </Popconfirm>
        </Space>
      )
    }
  ];

  return (
    <div style={{ margin: 10 }}>
      <Breadcrumb items={[{ title: <Link to="/">Home</Link> }, { title: 'Pages' }]} />
      <Row gutter={24} className="mt-4 mb-2">
        <Col span={12}>
          <Typography.Title level={4}>Pages List</Typography.Title>
        </Col>
        <Col span={12} className="text-right">
          <Link to="/pages/create">
            <Button type="primary" icon={<PlusOutlined />}>
              Add Page
            </Button>
          </Link>
        </Col>
      </Row>

      <Table
        dataSource={pages}
        columns={columns}
        size="middle"
        onChange={onTableChange}
        rowKey={(row) => row._id}
        pagination={{
          total: meta?.total,
          pageSize: meta?.limit
        }}
        loading={isLoading}
      />
    </div>
  );
}

export default PagesList;
